import { render } from "./NiceCounter.vue?vue&type=template&id=2ba1299f"
import script from "./NiceCounter.vue?vue&type=script&lang=js"
export * from "./NiceCounter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__